export function ComplaintHistorySectionSkeleton() {
  return (
    <div className="w-full md:px-4 px-2">
      <div className="h-7 w-[520px] max-w-full rounded bg-secondary" />
      <div className="mt-2 h-4 w-96 max-w-full rounded bg-secondary" />

      <div className="mt-6">
        <div className="h-4 w-60 rounded bg-secondary" />
        <div className="mt-4 space-y-6">
          <div className="h-10 w-[420px] max-w-full rounded bg-secondary" />
          <div className="h-10 w-[420px] max-w-full rounded bg-secondary" />
          <div className="h-10 w-[420px] max-w-full rounded bg-secondary" />
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="h-80 rounded-2xl bg-secondary" />
        <div className="h-80 rounded-2xl bg-secondary" />
        <div className="h-80 rounded-2xl bg-secondary" />
        <div className="h-80 rounded-2xl bg-secondary" />
      </div>
    </div>
  );
}
